// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_H91","cls2":"Filter-cls2_46I Filter-cls1_H91"};